<template>
  <div class="contact-frame">
    <Content :routeArr="routeArr" />

    <!-- pc -->
    <div class="box" v-if="!isMobile">
      <!-- 联系我们 -->
      <ul class="list" v-if="aboutList.length != 0">
        <li class="item" v-for="item in aboutList" :key="item.id">
          <div class="left">
            <div class="introTitle">{{ item.companyName }}</div>
            <div class="introPhone">
              <i class="icon el-icon-phone-outline"></i>
              <p class="text">{{ item.companyPhone }}</p>
            </div>
            <div class="introText">
              <i class="icon el-icon-location-information"></i>
              <p class="text" v-html="item.companyAddress"></p>
            </div>
          </div>
          <div class="right">
            <BaseMap :ref="'mapDom' + item.id" :itemId="item.id" />
          </div>
        </li>
      </ul>
      <!-- 加入我们 -->
      <div class="job-box" v-if="jobList.length != 0">
        <div class="job-item" v-for="item in jobList" :key="item.id">
          <div class="job-title">
            <div class="info-name">{{ item.jobName }}</div>
            <div class="info-price">
              {{ item.moneyMin }}——{{ item.moneyMax }}
            </div>
          </div>
          <div class="info-box">
            <div class="info-left" v-html="item.dutyContent"></div>
            <div class="info-right" v-html="item.requireContent"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="m-box" v-else>
      <van-tabs v-model="childCode" @change="toChange">
        <van-tab
          :title="item.name"
          :name="item.code"
          v-for="item in $store.state.subList"
          :key="item.id"
        >
          <!-- 联系我们 -->
          <ul class="list" v-if="aboutList.length != 0">
            <li class="item" v-for="item in aboutList" :key="item.id">
              <div class="top">{{ item.companyName }}</div>
              <div class="middle">
                <BaseMap :ref="'mapDom' + item.id" :itemId="item.id" />
              </div>
              <div class="bottom">
                <div class="introPhone">
                  <img
                    src="http://santa.pangodyun.com/images/contactIcon1.png"
                    alt=""
                  />
                  <p class="text">{{ item.companyPhone }}</p>
                </div>
                <div class="introText">
                  <img
                    src="http://santa.pangodyun.com/images/contactIcon2.png"
                    alt=""
                  />
                  <p class="text">{{ dealAddr(item.companyAddress) }}</p>
                </div>
              </div>
            </li>
          </ul>
          <!-- 加入我们 -->
          <div class="job-box" v-if="jobList.length != 0">
            <div class="job-item" v-for="item in jobList" :key="item.id">
              <div class="job-title">
                <div class="info-name">{{ item.jobName }}</div>
                <div class="info-price">
                  {{ item.moneyMin }}——{{ item.moneyMax }}
                </div>
              </div>
              <div class="info-box">
                <div class="info-left" v-html="item.dutyContent"></div>
                <div class="info-right" v-html="item.requireContent"></div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Content from "@/components/content.vue";
import BaseMap from "@/components/BaseMap.vue";
import { syscompanysList } from "../../util/organization/company";
import { sysJobList } from "../../util/job/job";
export default {
  data() {
    return {
      params: {
        pageIndex: 1,
        pageSize: 20,
      },
      nowDetail: [],
      aboutList: [],
      jobList: [],
      routeArr: [],
      isMobile: sessionStorage.getItem("isMobile"),
      childCode: "",
    };
  },
  components: {
    BaseMap,
    Content,
  },
  computed: {
    dealAddr() {
      return (addr) => {
        return addr.replace(/\n/g, "<br>");
      };
    },
  },
  created() {
    let that = this;
    this.childCode = sessionStorage.getItem("childCode");
    sessionStorage.removeItem("childCode");
    this.$store.state.subList.forEach((ele) => {
      if (ele.code == this.childCode) {
        // 加入我们
        if (ele.routeName == "/contact/join") {
          this.getJob();
        }
        // 联系我们
        if (ele.routeName == "/contact/contactWay") {
          this.getCompany();
        }
      }
    });
    const res = this.$store.state.subList.some(
      (ele) => ele.code == that.childCode
    );
    if (!res) {
      this.getCompany();
    }
  },
  mounted() {
    this.routeArr = [
      { name: "首页", path: "/" },
      { name: this.$store.state.name, path: "/contact" },
    ];
  },
  methods: {
    toChange(name) {
      this.$store.state.subList.forEach((ele) => {
        if (ele.code == name) {
          // 加入我们
          if (ele.routeName == "/contact/join") {
            this.getJob();
            this.aboutList = [];
          }
          // 联系我们
          if (ele.routeName == "/contact/contactWay") {
            this.getCompany();
            this.jobList = [];
          }
        }
      });
    },
    getLocation(val, id) {
      this.$nextTick(() => {
        this.$refs[`mapDom${id}`][0].markLocation(`container${id}`, val);
      });
    },
    getCompany() {
      // 公司地址 api
      syscompanysList(this.params).then((res) => {
        this.nowDetail = res.data[0];
        this.aboutList = res.data;
        res.data.forEach((ele) => {
          const location = {
            latitude: ele.latitude,
            longitude: ele.longitude,
            companyName: ele.companyName,
          };
          this.getLocation(location, ele.id);
        });
      });
    },
    getJob() {
      // 招聘 api
      sysJobList(this.params).then((res) => {
        this.jobList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.contact-frame {
  height: fit-content;

  .list {
    width: 1200px;
    margin: 60px auto;
    .item {
      margin-bottom: 40px;
      display: flex;

      .left {
        width: 600px;
        line-height: 22px;

        .introTitle {
          border-left: 5px $theme solid;
          padding-left: 20px;
          box-sizing: border-box;
          font-size: 22px;
        }
        .introPhone,
        .introText {
          font-size: 16px;
          line-height: 18px;
          margin-left: 25px;
          margin-top: 50px;
          display: flex;

          .text {
            margin-left: 10px;
          }
        }
        .introText {
          margin-top: 20px;
        }
      }
      .right {
        flex-grow: 1;
      }
    }
  }

  .job-box {
    width: 1200px;
    margin: 60px auto;
    .job-item {
      .job-title {
        display: flex;
        line-height: 40px;
        margin: 30px 0 20px;

        .info-name {
          font-size: 25px;
          width: fit-content;
          color: #333333;
        }
        .info-price {
          margin-left: 20px;
          font-weight: 400;
        }
      }
      .info-box {
        display: flex;

        .info-left {
          margin-right: 10px;
        }

        .info-left,
        .info-right {
          flex-grow: 1;
        }
      }
    }
  }

  .m-box {
    padding: 0 pxToRem(30);
    .list {
      width: 100%;
      margin: 0 0 pxToRem(40);
    }
    .item {
      display: block;

      .top {
        border-left: 5px $theme solid;
        padding-left: 20px;
        margin-bottom: pxToRem(20);
        box-sizing: border-box;
        font-size: pxToRem(15);
      }
      .bottom {
        margin-top: pxToRem(20);
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: pxToRem(7);
        padding: pxToRem(20);

        .introPhone,
        .introText {
          display: flex;

          img {
            width: pxToRem(14);
            height: pxToRem(14);
          }
          .text {
            font-size: pxToRem(14);
            margin-left: pxToRem(10);
          }
        }
      }
    }

    .job-box {
      width: 100%;
      margin: 0 0 pxToRem(30);

      .job-item {
        margin-bottom: pxToRem(30);
        &::before {
          content: "";
          display: table;
        }

        .job-title {
          display: block;
          margin: 0 0 pxToRem(10);

          .info-price {
            margin-left: 0;
          }
        }
        .info-box {
          display: block;

          .info-right {
            margin-top: pxToRem(20);
          }
        }
      }
    }
  }
}
@media (max-width: 1300px) {
  .contact-frame .list {
    width: 1000px;

    .item .left {
      width: 500px;
    }
  }
}
@media (max-width: 1024px) {
}
</style>
